import { createContext, useContext } from "react";

import type { ToastContextValueInterface } from "@/interfaces";

export const ToastContext = createContext<ToastContextValueInterface | null>(null);

export const useToast = (): ToastContextValueInterface => {
    const value = useContext(ToastContext);

    if (!value) throw new Error("useToast must be used within a ToastProvider");

    return value;
};
